<template>
  <div id="index">
    <div>
      <img src="../../assets/images/3x/home_swipe.png" alt="" style="width: 100%">
    </div>
    <div>
      <div id="yz_list">
        <div v-for="(item,index) in rz_list" :key="index">
          <div class="list_item" v-if="item.is_display==1">
            <div class="list_content">
              <div style="display: flex;align-items: center">
                <img :src="item.logo_url" alt="" style="width: 0.6rem;">
                <span class="item_text">{{item.verify_name2}}</span>
              </div>
              <div class="btn_box">
                <div v-show="item.is_true==2">{{$t('message.index_shcg')}}</div>
                <div v-show="item.is_true==1" @click="gorz(item,index)">{{$t('message.index_dws')}}</div>
                <van-icon name="arrow"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 90%;margin: 50px auto 10px;text-align: center">
      <van-button block round @click="goSecdule" id="btn_default">{{btnText}}</van-button>
      <span style="margin-top: 10px;display: inline-block;text-decoration: underline;" @click="goMine" id="mine_text">{{$t('message.index_grzx')}}</span>
    </div>
  </div>
</template>

<script>
  import {getAllNews} from '../../ports/port'
  import {postRenInfo, sassIndex,isLogin} from '../../ports/port'
  import {getBorrowMoney} from '../../ports/port'

  export default {
    name: "index",
    data() {
      return {
        loanValue: 50,
        value: 100,
        tk: JSON.parse(localStorage.getItem("tokenAll")),
        baseDate: {},//首页聚合接口里的数据
        btnText: '',//按钮文本
        btnStatus: true,//按钮状态,默认按钮的disabled是启用的
        btnUrl: '',//点击按钮后，跳转的地址
        defaultMount: '0',//默认额度
        rz_list: [],
        current_index: 0,//设置当前的未认证的位置
        over_yys_index: 0,//跳过运营商
        hasNovarify: false,//判断是否还有认证未认证，false没有，true有
        goPageType: 1,//1查看进度，0申请订单
        active: 0,
        basc_info_hasVar: false,//判断基本信息是否认证，认证了就可以进银行卡绑定，否则不行,
        broadcast_show:false//广播是否展示
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.$store.commit('edit', true);//打开全局的loading
      sassIndex({userid: this.tk.userid})
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.is_order == 1 && res.data.data.is_rejected==0) {
              this.btnText = this.$t('message.index_jdcx');
              this.goPageType = 1;
            } else if(res.data.data.is_order==0 || res.data.data.is_rejected==1){
              this.btnText = this.$t('message.borrow_lijk');
              this.goPageType = 0;
            }
          } else {
            this.$notify({
              type: 'danger',
              message: res.data.msg
            });
          }
        });
      postRenInfo({userid: this.tk.userid})
        .then(res => {
          this.rz_list = res.data.data;
          this.rz_list.forEach((item, index) => {
            //is_true=>1未认证 2已认证   is_display=》1显示 0不显示   is_varify=》1必须认证  0不必须认证
            if (item.veriry_desc == '基本信息认证' && item.is_true == 2) {
              this.basc_info_hasVar = true;
            }
            if (item.is_true == 1 && item.is_display == 1 && item.is_varify == 1) {
              this.hasNovarify = true;
            }
          });
          this.$store.commit('edit', false);//关闭全局的loading
        })
        .catch(err => {
          this.$store.commit('edit', false);//关闭全局的loading
          if (err.toString().indexOf('timeout') != -1) {
            this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
          }
        });

      //判断当前时间是否大于存储的广播倒计时 大于则隐藏，小于展示
      if(Date.now()>localStorage.getItem('broadcast')){
        this.broadcast_show=false;
      }else{
        this.broadcast_show=true;
      }
    },
    methods: {
      onChange(value) {

      },
      whereGo() {
        this.$router.push(this.btnUrl);
      },
      //数据处理，变成3个数字一个点
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        var result = '';
        while (num.length > 3) {
          result = '.' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) {
          result = num + result;
        }
        return result;
      },
      goSecdule() {
        if (this.hasNovarify == true) {
          this.$notify({
            type: 'danger',
            message: this.$t('message.index_rz_tips')
          });
        } else {
          if (this.goPageType == 1) {
            this.$router.push('/schedule')
          } else {
            this.$router.push('/borrow')
          }

        }

      },
      gorz(a, b) {
        switch (a.veriry_desc) {
          case '基本信息认证':
            this.$router.push("/photos");
            break;
          case '社交认证':
            this.$router.push("/Social");
            break;
          case '运营商':
            this.$router.replace("/yys");
            break;
          case '银行卡认证':
            if (this.basc_info_hasVar) {
              this.$router.push("/banks");
            } else {
              this.$toast(this.$t('message.first_rz'))
            }
            break;
        }
      },
      goMine() {
        this.$router.push('/home/my')
      }
    }
  }
</script>

<style scoped lang="scss">
  #index {
    background: #F8F8F8;
    min-height: 100vh;
    /*padding-bottom: 50px;*/
    #yz_list {
      min-height: 6rem;

      .list_item {
        margin: 10px auto;
        width: 90%;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.17);
        margin-bottom: 10px;
        height: 1.31rem;
        line-height: 1.31rem;
        padding: 0 0.31rem;

        position: relative;
        border-bottom: 1px solid #f5f5f5;

        .circle {
          width: 6px;
          height: 6px;
          background: #4a4a4a;
          position: absolute;
          left: -23px;
          top: 22px;
          border-radius: 6px;
        }

        .isver_circle {
          position: absolute;
          left: -27px;
          top: 0px;
        }

        .list_content {
          display: flex;
          align-content: center;
          justify-content: space-between;

          .btn_box {
            padding-bottom: 5px;
            display: flex;
            align-items: center;
            div{
              color: #9E9E9E;
              margin-right: 0.1rem;
            }
            i{
              color: #9E9E9E;
            }
          }
          .item_text{
            color: #767676;
            margin-top: -4px;
          }
          img{
            margin-right: 0.17rem;
          }
        }

      }
    }

    #btn_default {
      @include defaultBtn
    }

    #mine_text {
      color: $color;
    }
    .notice-swipe {
      height: 0.5rem;
      line-height: 0.5rem;
    }
    /deep/ .van-notice-bar{
      height: 24px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/editBascInfo.vue